import { config } from '../config';
import { createFixtureSource } from './fixture/fixture';
import type { C3DataSource, C3SourceKind } from './ports';
import { createRengloSource } from './renglo/renglo';

/**
 * Where the console starts: Demo, the invented tenant, so it opens with data and no API. `REACT_APP_DATA_SOURCE=renglo`
 * starts it Live, on the API. The Demo/Live switch changes it at run time.
 */
export const DEFAULT_SOURCE_KIND: C3SourceKind = 'fixture';

/** `REACT_APP_DATA_SOURCE`: `renglo` or `fixture`. Empty or anything else means the default, `fixture`. */
export function resolveSourceKind(raw: string = config.dataSource): C3SourceKind {
  return raw.trim().toLowerCase() === 'renglo' ? 'renglo' : DEFAULT_SOURCE_KIND;
}

export function createDataSource(kind: C3SourceKind): C3DataSource {
  return kind === 'fixture' ? createFixtureSource() : createRengloSource();
}

let current: C3DataSource | null = null;

/**
 * The source the app reads from now. Made once, so the fixture's records keep their dates. The data provider
 * sets it when the person switches between Demo and Live, so code that reads outside a component (the route
 * resolvers) follows the same source.
 */
export function getDataSource(): C3DataSource {
  if (!current) current = createDataSource(resolveSourceKind());
  return current;
}

export function setActiveDataSource(source: C3DataSource): void {
  current = source;
}

/** For tests: forget the source made so far. */
export function resetDataSource(): void {
  current = null;
}
